<template>
  <el-menu text-color="#3d3533" active-text-color="#ffffff" default-active="1" class="menu-tree" @select="handleSelect">
    <el-menu-item index="1">
            <span slot="title">全部</span>
          </el-menu-item>
    <el-menu-item index="2">
            <span slot="title">日程</span>
          </el-menu-item>
        <el-menu-item index="3">
            <span slot="title">日报</span>
          </el-menu-item>
        <el-menu-item index="4">
            <span slot="title">会议</span>
          </el-menu-item>
        <el-menu-item index="5">
            <span slot="title">审批中心</span>
          </el-menu-item>
        <el-menu-item index="6">
            <span slot="title">通知公告</span>
          </el-menu-item>
        <el-menu-item index="7">
            <span slot="title">收文</span>
          </el-menu-item>
  </el-menu>
</template>

<script>
export default {
  mounted() {
    // 初始化时设置高度
    this.setMenuHeight();
    // 监听窗口大小变化
    window.addEventListener('resize', this.setMenuHeight);
  },
  beforeDestroy() {
    // 组件销毁前移除监听
    window.removeEventListener('resize', this.setMenuHeight);
  },
  methods: {
    setMenuHeight() {
      const menu = document.querySelector('.menu-tree');
      if (menu) {
        menu.style.height = `${window.innerHeight - 70}px`;
      }
    },
    handleSelect(index) {
      this.$emit('handleSelect', index)
    },
  }
}
</script>

<style scoped>
.menu-tree {
  height: calc(100vh - 30px) !important; /* 初始高度设置为视口高度 */
  overflow-y: hidden; /* 内容超出时显示滚动条 */
  background-color: transparent; /* 可选：设置背景色 */
  padding-top: 12px;
  font-size: 14px;
  margin-left: 4px;
}

/* 可选：美化滚动条样式 */
.menu-tree::-webkit-scrollbar {
  width: 6px;
}

.menu-tree::-webkit-scrollbar-thumb {
  background-color: #dcdfe6;
  border-radius: 3px;
}

.menu-tree::-webkit-scrollbar-track {
  background-color: #f5f7fa;
}

.el-menu-item.is-active {
  background-color:#bb0009 !important;
}
.el-menu-item {
  height: auto;
  line-height:40px;
  border-radius: 5px !important;
  margin-bottom: 8px;
  font-size: -apple-system,BlinkMacSystemFont,"Segoe UI","PingFang SC","Hiragino Sans GB",STHeitiSC,Helvetica,"Helvetica Neue","Microsoft YaHei",Tahoma;
}
.el-menu-item:hover {
  background-color: rgba(255,157,138,0.2) !important;
}
</style>


// WEBPACK FOOTER //
// src/views/message-center/components/menuTree.vue